import { getData, postData, putData } from "../api/api";

export type AccountProfile = {
  id: string;
  username?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  emailVerified?: boolean;
};

export type UpdateAccountProfileRequest = {
  firstName?: string;
  lastName?: string;
};

export type ChangePasswordRequest = {
  currentPassword: string;
  newPassword: string;
};

export const accountService = {
  getProfile: () => getData("/account/me") as Promise<AccountProfile>,
  updateProfile: (body: UpdateAccountProfileRequest) =>
    putData("/account/me", body) as Promise<AccountProfile>,
  changePassword: (body: ChangePasswordRequest) =>
    postData("/account/me/password", body) as Promise<{ message: string; reloginRequired?: string }>,
};
